import { Link } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import PropTypes from "prop-types";
import DeletePost from "./DeletePost";
import PostDialog from "./PostDialog";
import LikeButton from "./LikeButton";

//Material Ui Stuff
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

//Redux Stuff
import { connect } from "react-redux";

const styles = {
  root: {
    minWidth:275,
    marginBottom: "0.8rem",
  },
  header: {
    width: "100%",
  },
  title: {
    fontSize: 14,
    lineHeight: "18px",
  },
};

dayjs.extend(relativeTime);

const Post = (props) => {
  const {
    classes,
    openDialog,
    commentC,
    post: {
      body,
      createdAt,
      userImage,
      username,
      postId,
      likeCount,
      commentCount,
    },
    user: { authenticated, credentials },
  } = props;

  const deleteButton =
    authenticated && username === credentials.username ? (
      <DeletePost postId={postId} />
    ) : null;

  const commentNumberCount = commentC ? commentC : commentCount;
  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        avatar={<Avatar src={userImage} aria-label="profile image" />}
        action={deleteButton}
        title={
          <Typography
            component={Link}
            color="primary"
            variant="h6"
            to={`/users/${username}`}
          >
            @{username}
          </Typography>
        }
        subheader={
          <Typography variant="body2" style={{ color: "#5b7083" }}>
            {dayjs(createdAt).format("h:mma, MMMM DD YYYY")}
          </Typography>
        }
      />
      <Divider variant="fullWidth" />
      <CardContent component="div">
        <Typography
          variant="body1"
          alignItems="center"
          style={{
            color: "#0f1419",
            lineHeight: "20px",
            fontWeight: "400",
            alignItems:"center"
          }}
          display="block"
          gutterBottom
        >
          {body}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <LikeButton postId={postId} />
        <span>{likeCount} Likes</span>
        <PostDialog
          postId={postId}
          username={username}
          openDialog={openDialog}
        />
        <span>{commentNumberCount} Comments</span>
      </CardActions>
    </Card>
  );
};

Post.propTypes = {
  user: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  openDialog: PropTypes.bool,
  commentC: PropTypes.number,
};

const mapStateToProps = (state) => ({
  user: state.user,
  commentC: state.data.post.commentCount,
});

export default connect(mapStateToProps)(withStyles(styles)(Post));
